module.exports = __webpack_public_path__ + "assets/img/kosher.4a531af2.svg";